import { defaultImage, storageBaseUrl } from 'configs/settings';

export const getFullUrl = url => {
  return url ? storageBaseUrl + '/' + url : defaultImage;
};
